import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinArray',
  standalone: true,
})
export class JoinArrayPipe implements PipeTransform {
  transform(value: any | any[], separator: string = ', ') {
    if (Array.isArray(value)) {
      return value.join(separator);
    }
    return value;
  }
}
